<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'intercoms')" class="tab__footer page__active_bar">
      <el-button class="page__active_button" type="primary" @click="addDialog = true">
        Добавить домофон <i class="el-icon-plus" />
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-table v-loading="loading" class="list" :data="intercoms">
        <el-table-column prop="short_name" label="Домофон">
          <template slot-scope="scope">
            <router-link class="link" :to="{ name: 'intercom:edit', params: { id: scope.row.id_intercom } }">
              {{ scope.row.short_name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="uuid" label="UUID" />
        <el-table-column prop="apartment" label="Квартира" />
        <el-table-column align="center" width="120px" v-if="$can('delete', 'intercoms')" label="Действия">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="onRemove(scope.row.id_intercom)">
              Удалить <fa :icon="['fas', 'trash-alt']" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <client-intercom-dialog
      :client-id="clientId"
      :visible.sync="addDialog"
      @added="updateIntercomsList"
      @closed="addDialog = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ClientIntercomDialog from "@/components/Client/components/features/ClientIntercomDialog";

library.add(faTrashAlt);

export default {
  name: "ClientIntercomsTab",
  components: { ClientIntercomDialog, fa },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      addDialog: false,
    };
  },
  computed: {
    ...mapState("client", ["intercoms"]),
  },
  watch: {
    clientId: {
      immediate: true,
      handler() {
        this.updateIntercomsList();
      },
    },
  },
  methods: {
    ...mapActions("client", {
      getIntercoms: "GET_CLIENT_INTERCOMS",
      deleteIntercom: "DELETE_CLIENT_INTERCOM",
    }),
    updateIntercomsList() {
      this.loading = true;
      this.getIntercoms(this.clientId).finally(() => {
        this.loading = false;
      });
    },
    onRemove(id) {
      const intercom = this.intercoms.find((i) => i.id_intercom === id);
      this.$confirm(`Вы точно хотите удалить домофон "${intercom.short_name} у этого клиента?"`, "Подтверждение", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        type: "warning",
      }).then(() => this.remove(id));
    },
    remove(id) {
      this.deleteIntercom({ clientId: this.clientId, idIntercom: id })
        .then(() => {
          this.$message({
            message: "Домофон удален",
            type: "success",
          });
          this.updateIntercomsList();
          this.$emit("intercomDeleted");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Ошибка при удалении домофона");
        });
    },
  },
};
</script>
